import React, { useMemo } from 'react'
import ReactTooltip from 'react-tooltip'

const useStudentColumns = ({ onDelete }) => {
  return useMemo(() => {
    const columns = [
      { Header: 'Data', accessor: 'DataConsulta', },
      {
        Header: 'Status',
        accessor: 'Status',
        Cell: ({ row: { original: { Status } } }) => {
          let color = '#f00'

          if (Status === 'Aprovado')
            color = '#18b840'
          else if (Status === 'Lista de espera')
            color = '#f90'

          return (
            <div className="student-status">
              <div
                className="dot"
                style={{
                  display: 'block',
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  background: color,
                  marginRight: '5px',
                }}
              />
              <span className="status">{Status}</span>
            </div>
          )
        },
      },
      { Header: 'Inscrição', accessor: 'CodigoInscricaoENEM', },
      { Header: 'Nome do Estudante', accessor: 'NomeInscrito', },
      {
        Header: 'IES',
        accessor: 'SiglaInstituicao',
        Cell: ({ row: { original: { SiglaInstituicao, NomeInstituicao } } }) => (
          <>
            <ReactTooltip effect="float" data-place="top" />

            <span style={{ fontWeight: 400 }} data-tip={NomeInstituicao}>
              {SiglaInstituicao}
            </span>
          </>
        )
      },
      { Header: 'Curso', accessor: 'NomeCurso', },
      { Header: 'Nota', accessor: 'NotaCandidato', },
      { Header: 'Classificação', accessor: 'Classificacao', },
      {
        Header: 'Ano',
        accessor: 'Ano',
        Cell: ({ row: { original: { CodigoInscricaoENEM } } }) => {
          if (CodigoInscricaoENEM != null && CodigoInscricaoENEM.length > 2) {
            const year = parseInt(CodigoInscricaoENEM.slice(0, 2)) + 1
            return `20${year}`
          }

          return null
        }
      },
      {
        Header: 'Modalidade',
        accessor: 'Modalidade',
        Cell: ({ row: { original: { Modalidade } } }) => (
          <>
            <ReactTooltip effect="float" data-place="top" />

            <span data-tip={Modalidade}>
              {String(Modalidade).length > 18 ? String(Modalidade).substring(0, 18) + '...' : Modalidade}
            </span>
          </>
        )
      },
    ]

    if (onDelete != null) {
      columns.push({
        Header: 'Ações',
        accessor: '',
        disableSortBy: true,
        Cell: ({ row: { index, original } }) => (
          <button style={{
            color: '#E94B4B',
            fontWeight: 600,
            backgroundColor: 'transparent',
            outline: 'none',
            border: 0,
          }} onClick={() => onDelete(index, original)}>x</button>
        ),
      })
    }

    return columns
  }, [onDelete])
}

export default useStudentColumns
